<style scoped>
.width150 {
  width: 150px;
}
</style>
<template>
  <div>
    <div style="background-color: #fff; padding: 16px; margin-bottom: 20px">
      <a-form-model
        size="small"
        layout="inline"
        :model="ajaxparams"
        @keyup.native.enter="$refs.myTable.search()"
      >
        <a-form-model-item label="经理名称">
          <a-input
            class="width150"
            allowClear
            placeholder="请输入经理名称"
            v-model="ajaxparams.manager_name"
          />
        </a-form-model-item>
        <a-form-model-item label="客户名称">
          <a-input
            class="width150"
            allowClear
            placeholder="请输入客户名称"
            v-model="ajaxparams.customer_name"
          />
        </a-form-model-item>
        <a-form-model-item label="发放日期">
          <a-range-picker
            v-model="dateRange"
            format="YYYY-MM-DD"
            valueFormat="YYYY-MM-DD"
            :placeholder="['开始日期', '结束日期']"
            @change="onDateRangeChange"
          />
        </a-form-model-item>
        <a-form-model-item>
          <a-button
            icon="search"
            type="primary"
            @click="$refs.myTable.search()"
          >
            搜索
          </a-button>
        </a-form-model-item>
      </a-form-model>

      <MyTable
        class="mt10"
        :apiUrl="renewalBonus_index"
        :params="ajaxparams"
        :columns="columns"
        :isSelection="false"
        ref="myTable"
      >
        <a-space slot="button" slot-scope="item, row">
          <a-popconfirm
            title="确定删除该发放记录？将扣除客户对应抵扣券余额。"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(row)"
          >
            <a-button type="danger" size="small">删除</a-button>
          </a-popconfirm>
        </a-space>
        <a-space slot="amount" slot-scope="item, row">
          <span>{{ formatAmount(row.amount) }}</span>
        </a-space>
        <a-space slot="is_expired" slot-scope="item, row">
          <a-tag :color="row.is_expired ? 'red' : 'green'">
            {{ row.is_expired ? "已过期" : "未过期" }}
          </a-tag>
        </a-space>
      </MyTable>
    </div>
  </div>
</template>
<script>
import MyTable from "@/components/myTable.vue";
import {
  renewalBonus_index,
  renewalBonus_delete,
} from "@/api/renewalBonus";

export default {
  components: { MyTable },
  data() {
    return {
      renewalBonus_index,
      dateRange: [],
      ajaxparams: {
        manager_name: undefined,
        customer_name: undefined,
        start_date: undefined,
        end_date: undefined,
      },
      columns: [
        {
          title: "操作",
          key: "operation",
          fixed: "left",
          width: 100,
          scopedSlots: { customRender: "button" },
        },
        {
          title: "发放日期",
          ellipsis: true,
          width: 180,
          dataIndex: "created_at",
          key: "created_at",
        },
        {
          title: "经理",
          ellipsis: true,
          width: 140,
          dataIndex: "manager_name",
          key: "manager_name",
        },
        {
          title: "客户",
          ellipsis: true,
          width: 140,
          dataIndex: "customer_name",
          key: "customer_name",
        },
        {
          title: "券额",
          width: 120,
          dataIndex: "amount",
          key: "amount",
          scopedSlots: { customRender: "amount" },
        },
        {
          title: "到期时间",
          ellipsis: true,
          width: 140,
          dataIndex: "expire_at",
          key: "expire_at",
        },
        {
          title: "状态",
          width: 100,
          dataIndex: "is_expired",
          key: "is_expired",
          scopedSlots: { customRender: "is_expired" },
        },
      ],
    };
  },
  methods: {
    onDateRangeChange(dates) {
      this.ajaxparams.start_date =
        dates && dates.length ? dates[0] : undefined;
      this.ajaxparams.end_date = dates && dates.length ? dates[1] : undefined;
    },
    formatAmount(value) {
      return (Number(value || 0) / 100).toFixed(2);
    },
    handleDelete(row) {
      renewalBonus_delete({ id: row.id }).then(() => {
        this.$message.success("删除成功");
        this.$refs.myTable.getList();
      });
    },
  },
};
</script>
